import createActionTypes from '../utils/create_action_types';

/**
 * Shared/Generic Action Types
 */
export const DATA = createActionTypes('DATA', [
  'REQUEST',
  'SUCCESS',
  'FAILURE',
  'GROUPS',
  'TRAINERS',
  'PAST_OR_UPCOMING',
  'EVENT_CREATORS',
]);

export const BULK_ACTIONS = createActionTypes('BULK_ACTIONS', {
  LIST: ['TOGGLE_ITEM', 'ADD_ALL', 'REMOVE_ALL'],
  SUBMIT: ['REQUEST', 'SUCCESS', 'FAILURE', 'DONE'],
  MASS_ACTION: ['DONE'],
});

export const MASS_ACTIONS = createActionTypes('MASS_ACTIONS', {
  SHARED: ['REQUEST', 'REQUEST_SUCCESS', 'REMOVE_ALL', 'UPDATED'],
});

/**
 * Filters Action Types
 */
export const FILTER = createActionTypes('FILTER', {
  SORT: 'SORT',
  UPDATE: [
    'ALL',
    'PAGE',
    'QUERY',
    'DATE',
    'TAGS',
    'SINGLE_TAG',
    'CREATOR',
    'INSTRUCTOR',
    'CONTENT_TYPE',
    'TYPE',
    'GROUPS',
    'ROLE',
    'MANAGER',
    'PER_PAGE',
    'ACTIVE_GROUP',
    'EDITING',
    'WORKSPACE',
    'MY_ORGANIZATION',
    'PAST_OR_UPCOMING',
    'SKILL_TAGS',
  ],
  CLEAR: 'CLEAR',
});

export const DEFAULT_VIEW = createActionTypes('DEFAULT_VIEW', [
  'SET_VIEW_STATE',
]);

export const TRAINING_DEFAULT_VIEW = createActionTypes(
  'TRAINING_DEFAULT_VIEW',
  ['SET_VIEW_STATE'],
);

/**
 * Editor Actions
 */
export const EDITOR = createActionTypes('EDITOR', {
  AUTOSAVE: ['REQUEST', 'SUCCESS', 'FAILURE'],
  TOGGLE: ['DRAGGING_ELEMENT', 'ADD_TO_IMAGE_LIBRARY'],
  COMMENTARY: [
    'SHOW',
    'HIDE',
    'REQUEST',
    'REQUEST_SUCCESS',
    'REQUEST_FAILURE',
    'CREATE_THREAD',
    'RESOLVE_THREAD',
    'POST_REPLY',
    'SET_ACTIVE_THREAD',
    'SET_UNACTIVE_THREAD',
  ],
  LESSON: ['UPDATE', 'REFRESH_INVALID_SECTIONS'],
  SECTION: [
    'UPDATE',
    'CREATE',
    'REQUEST_CREATE',
    'DELETE',
    'REQUEST_DELETE',
    'EDIT',
    'REQUEST_EDIT',
    'UPDATE_URL',
    'REORDER',
    'DUPLICATE',
  ],
  ELEMENT: [
    'SET_VALIDITY',
    'UPDATE_COMMENTS_COUNT',
    'DELETE',
    'REQUEST_DELETE',
    'DELETE_CHILDREN',
    'APPLY_CHANGES',
    'CREATE',
    'REORDER',
    'DETACH_PARENT',
    'ASSIGN_PARENT',
    'REPLACE',
  ],
  INTEGRATIONS: ['DATA_REQUEST', 'DATA_RECEIVE', 'DATA_FAILURE'],
  TEMPLATE: [
    'UPDATE',
    'TOGGLE_STATUS',
    'IMAGE_CHANGE',
    'TOGGLE_ADD_TO_LIBRARY',
    'TOGGLE_IMAGE_LIBRARY',
    'TOGGLE_IMAGE_SUCCESS',
  ],
});

/**
 * Assign Modal
 */
export const ASSIGN = createActionTypes('ASSIGN', {
  STEP: ['SET_ACTIVE'],
  CONTENT: ['SET_TYPE'],
  DATA: [
    'RESET',
    'REQUEST',
    'REQUEST_SUCCESS',
    'REQUEST_JOURNEYS_SUCCESS',
    'REQUEST_NEXT_PAGE_SUCCESS',
  ],
  PARAMS: [
    'UPDATE_QUERY',
    'UPDATE_SORT',
    'UPDATE_FILTER_TYPE',
    'UPDATE_JOURNEY_SORT',
  ],
  ITEM: ['SELECT', 'DESELECT', 'SET_ASSIGNEES_COUNT'],
  SCHEDULE: ['UPDATE'],
  REVIEW: ['UPDATE_EXISTING_ASSIGNMENT_OPTION', 'UPDATE_MESSAGE'],
});

export const PATH_VIEWER = createActionTypes('PATH_VIEWER', {
  REQUEST_CONTENTS: ['IN_PROGRESS', 'ERROR', 'SUCCESS'],
});

export const JOURNEY_VIEWER = createActionTypes('JOURNEY_VIEWER', {
  REQUEST_CONTENTS: ['IN_PROGRESS', 'ERROR', 'SUCCESS'],
  UI: ['HIDE_START_BUTTON', 'SHOW_START_BUTTON'],
});

export const PATH_BUILDER = createActionTypes('PATH_BUILDER', {
  PATH: [
    'UPDATE',
    'UPDATE_IN_PROGRESS',
    'UPDATE_SUCCESS',
    'UPDATE_FAILURE',
    'UPDATE_FAILURE_DISMISS',
    'RESTORE_REVISION',
    'SAVE_REVISION',
    'SAVE_DRAFT',
    'SET_ESTIMATED_MINUTES_TO_COMPLETE',
    'PUBLISH',
    /**
     * @todo: move these under UI
     */
    'TOGGLE_EDITING_DESCRIPTION',
    'TOGGLE_EDITING_ORDER_ENFORCEMENT',
    'TOGGLE_EDITING_MODE',
  ],
  UI: [
    'TOGGLE_EDITING_BY_NAME',
    'SET_MODE',
    'SHOW_DEMONSTRATION_BUILDER',
    'HIDE_DEMONSTRATION_BUILDER',
  ],
  TAGGING: ['CREATE', 'REMOVE', 'TAG_ALL_CONTENT'],
  OWNERSHIP: ['CREATE', 'REMOVE', 'UPDATE'],
  RELATED_URLS: ['CREATE', 'REMOVE'],
  LIBRARY_CONTENT: ['CREATE', 'REMOVE'],
  CONTENT: [
    'UPDATE',
    'REORDER',
    'REMOVE',
    'ADD',
    'PERSIST',
    'TOGGLE_EDITING',
    'TOGGLE_DRAGGING',
    'LOADING_CONTENTS_REQUEST',
    'LOADING_CONTENTS_SUCCESS',
    'SHOW_NEW_DEMONSTRATION_FORM',
    'HIDE_NEW_DEMONSTRATION_FORM',
  ],
  REPORTING: ['SET_GROUP', 'DATA_REQUEST', 'DATA_SUCCESS'],
});

export const JOURNEY_BUILDER = createActionTypes('JOURNEY_BUILDER', {
  JOURNEY: [
    'UPDATE',
    'UPDATE_IN_PROGRESS',
    'UPDATE_SUCCESS',
    'UPDATE_FAILURE',
    'UPDATE_FAILURE_DISMISS',
    'UPDATE_DETAILS',
    'UPDATE_AUTOSAVE',
    'UPDATE_PUBLISHED',
    'BANNER',
  ],
  STEPS: ['ADD', 'UPDATE', 'REMOVE', 'REORDER'],
  UI: [
    'SHOW_EDIT_DETAILS',
    'HIDE_EDIT_DETAILS',
    'TOGGLE_PREVIEW',
    'DISPLAY_BANNER',
    'HIDE_BANNER',
  ],
});

export const LEARN = createActionTypes('LEARN', {
  CONTENTS: ['REQUEST', 'REQUEST_ERROR', 'RECEIVE'],
  JOURNEY_CONTENTS: ['RECEIVE'],
  SEARCH: [
    'READY',
    'SET_SOURCE_PAGE',
    'RESET_SOURCE_PAGE',
    'UPDATE_QUERY',
    'UPDATE_FILTER',
    'RESET_FILTERS',
  ],
});

export const IN_PERSON_TRAINING = createActionTypes('IN_PERSON_TRAINING', {
  EVENTS_DASHBOARD: [
    'DATA_REQUEST',
    'DATA_RECEIVE',
    'DATA_FAILURE',
    'TAB_SELECT',
  ],
  EVENT: ['UPDATE', 'DATA_REQUEST', 'DATA_RECEIVE', 'DATA_FAILURE'],
  SESSIONS: ['CREATE', 'REMOVE', 'UPDATE'],
  ATTENDANCES: [
    'CREATE',
    'REMOVE',
    'DATA_REQUEST',
    'DATA_RECEIVE',
    'SET_FILTERS',
  ],
  GUESTS: ['CREATE', 'REMOVE', 'DATA_REQUEST', 'DATA_RECEIVE', 'SET_FILTERS'],
  EVENT_CHANGE_MANAGEMENT: [
    'TOGGLE_UPDATE_EMAIL',
    'TOGGLE_CONFIRM_TRAINER_CHANGE',
  ],
  ASSOCIATED_CONTENT: [
    'ADD_ITEM',
    'ASSIGN_CONTENT',
    'DATA_FAILURE',
    'DATA_REQUEST',
    'DATA_SUCCESS',
    'REMOVE_FAILURE',
    'REMOVE_ITEM',
  ],
});

export const ROLES = createActionTypes('ROLES', {
  PERMISSIONS: ['REQUEST', 'RECEIVE', 'GRANT', 'REVOKE'],
});

export const ASSIGNMENTS = createActionTypes('ASSIGNMENTS', {
  DIRECT_ASSIGN: ['REQUEST', 'REQUEST_ERROR', 'RECEIVE'],
  ASSIGN_VIA_PATH: ['REQUEST', 'REQUEST_ERROR', 'RECEIVE'],
  ACTION: [
    'SELECT_ALL',
    'SELECT_SINGLE',
    'DELETE_ASSIGNMENT',
    'DELETE_BULK_ASSIGNMENT',
    'UPDATE_BULK_DATE',
    'UPDATE_DATE',
    'MARK_COMPLETE',
  ],
});
